class DealFilter {

  constructor(url) {
    this.url = url;
  }

  init() {
    $('.js-deal-filter').parent().find('.dropdown-item').click((e) =>  {
      let filterURL = e.currentTarget.dataset.filterUrl;

      this.loadDeals({
        sortBy: '',
        url: filterURL,
      });
    });

    $('.js-deal-sort').parent().find('.dropdown-item').click((e) => {
      let sortBy = e.currentTarget.dataset.sortBy;


      this.loadDeals({
        sortBy: sortBy,
      });
    });
  }

  loadDeals(params) {
    let currentURL = new URL(window.location.href);
    let newURL;


    if(params.url) {
      newURL = new URL(params.url);
    } else {
      newURL = currentURL;
    }

    // let filterParam = params.filterBy || currentURL.searchParams.get('filter');
    let sortParam = params.sortBy || currentURL.searchParams.get('sort');

    if(sortParam) {
      newURL.searchParams.set('sort', sortParam);
    }

    window.location.href = newURL.toString();
  }

}

export { DealFilter };
